// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const edgeAssertionOptionsSchema = z.object({
  "challenge": z.string(),
  "rpId": z.string().optional(),
  "timeout": z.number().int().optional(),
  "userVerification": z.enum(["required", "preferred", "discouraged"]).optional(),
  "allowCredentials": z.array(z.object({
    "type": z.enum(["public-key"]),
    "id": z.string(),
    "transports": z.array(z.enum(["ble", "hybrid", "internal", "nfc", "usb", "smart-card"])).optional()
  })).optional()
});

export const edgeGroupChangeSchema = z.object({
  "change": z.object({
    "format": z.enum(["pureid-edge-group-change-v1"]),
    "id": z.string().uuid(),
    "tenant_id": z.string().uuid(),
    "group_id": z.string().uuid(),
    "base_revision": z.number().int().min(0),
    "authority_revision": z.number().int().min(0),
    "before": z.object({
      "capabilities": z.array(z.object({
        "capability": z.enum(["agent_apis", "agent_outbound", "private_applications", "private_servers"]),
        "options": z.array(z.string().min(1).max(64)).max(4),
        "paused": z.boolean().optional(),
        "min_serving": z.number().int().min(0).max(1024),
        "ssh_authority": z.object({
          "fingerprint": z.string().regex(new RegExp("^SHA256:[A-Za-z0-9+/]{43}$")),
          "custody": z.enum(["hardware", "kms", "software"])
        }).strict().optional()
      }).strict()).max(4),
      "resources": z.array(z.object({
        "id": z.string().uuid(),
        "capability": z.enum(["agent_apis", "agent_outbound", "private_applications", "private_servers"]),
        "revision": z.number().int().min(1),
        "policy_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
        "target_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$"))
      }).strict()).max(5000)
    }).strict(),
    "after": z.object({
      "capabilities": z.array(z.object({
        "capability": z.enum(["agent_apis", "agent_outbound", "private_applications", "private_servers"]),
        "options": z.array(z.string().min(1).max(64)).max(4),
        "paused": z.boolean().optional(),
        "min_serving": z.number().int().min(0).max(1024),
        "ssh_authority": z.object({
          "fingerprint": z.string().regex(new RegExp("^SHA256:[A-Za-z0-9+/]{43}$")),
          "custody": z.enum(["hardware", "kms", "software"])
        }).strict().optional()
      }).strict()).max(4),
      "resources": z.array(z.object({
        "id": z.string().uuid(),
        "capability": z.enum(["agent_apis", "agent_outbound", "private_applications", "private_servers"]),
        "revision": z.number().int().min(1),
        "policy_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
        "target_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$"))
      }).strict()).max(5000)
    }).strict(),
    "before_release": z.unknown().refine((value) => [z.object({
      "version": z.string().min(1).max(100),
      "sequence": z.number().int().min(1),
      "sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
      "image_id": z.string().regex(new RegExp("^[0-9a-f]{64}$"))
    }).strict(), z.null()].filter((variant) => variant.safeParse(value).success).length === 1, "Expected exactly one supported variant").pipe(z.union([z.object({
      "version": z.string().min(1).max(100),
      "sequence": z.number().int().min(1),
      "sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
      "image_id": z.string().regex(new RegExp("^[0-9a-f]{64}$"))
    }).strict(), z.null()])),
    "release": z.object({
      "version": z.string().min(1).max(100),
      "sequence": z.number().int().min(1),
      "sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
      "image_id": z.string().regex(new RegExp("^[0-9a-f]{64}$"))
    }).strict(),
    "rollback": z.boolean(),
    "window": z.unknown().refine((value) => [z.object({
      "start": z.number().int(),
      "end": z.number().int()
    }).strict(), z.null()].filter((variant) => variant.safeParse(value).success).length === 1, "Expected exactly one supported variant").pipe(z.union([z.object({
      "start": z.number().int(),
      "end": z.number().int()
    }).strict(), z.null()])),
    "profile_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "plane_ca_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "config_sign_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "drain_seconds": z.number().int().min(0).max(3600),
    "prepared_at": z.number().int(),
    "approve_before": z.number().int(),
    "ticket": z.string().min(1).max(128).optional()
  }).strict(),
  "sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
  "phase": z.enum(["pending", "approved", "cancelled", "expired"]),
  "prepared_by": z.string().uuid(),
  "prepared_by_name": z.string(),
  "prepared_by_email": z.string(),
  "created_at": z.string().datetime({ offset: true }),
  "decided_at": z.string().datetime({ offset: true }).nullable(),
  "widens": z.boolean(),
  "added_capabilities": z.array(z.enum(["agent_apis", "agent_outbound", "private_applications", "private_servers"])).max(4),
  "removed_capabilities": z.array(z.enum(["agent_apis", "agent_outbound", "private_applications", "private_servers"])).max(4),
  "approve_before": z.string().datetime({ offset: true })
}).strict();

export const edgeGroupAdmissionSchema = z.object({
  "id": z.string().uuid(),
  "group_id": z.string().uuid(),
  "edge_id": z.string().uuid(),
  "kind": z.enum(["join", "extend"]),
  "name": z.string().min(1).max(100),
  "failure_domain": z.string().min(1).max(100),
  "destination": z.string().min(1).max(253),
  "basis_revision": z.number().int().min(0),
  "basis_change_id": z.string().uuid().nullable(),
  "phase": z.enum(["pending", "approved", "rejected", "stale", "expired"]),
  "sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
  "verification_code": z.string().regex(new RegExp("^[0-9A-F]{4}-[0-9A-F]{4}$")),
  "token_id": z.string().uuid(),
  "token_issued_by": z.string().uuid(),
  "submitted_from": z.string().max(64).nullable(),
  "submitted_at": z.string().datetime({ offset: true }),
  "expires_at": z.string().datetime({ offset: true }),
  "decided_at": z.string().datetime({ offset: true }).nullable(),
  "workers": z.array(z.object({
    "worker_id": z.string().uuid(),
    "capability": z.enum(["agent_apis", "agent_outbound", "private_applications", "private_servers"]),
    "enrollment_key_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "evidence_kid": z.string().min(1).max(128),
    "image_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$"))
  }).strict()).max(4)
}).strict();

export const edgeGroupRolloutSchema = z.object({
  "change_id": z.string().uuid(),
  "release_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
  "release_version": z.string().min(1).max(100),
  "rollback": z.boolean(),
  "state": z.enum(["running", "paused", "halted", "completed", "cancelled", "superseded"]),
  "window_start": z.string().datetime({ offset: true }).nullable(),
  "window_end": z.string().datetime({ offset: true }).nullable(),
  "current_edge_id": z.string().uuid().nullable(),
  "current_since": z.string().datetime({ offset: true }).nullable(),
  "updated": z.number().int().min(0),
  "edges": z.number().int().min(0),
  "created_at": z.string().datetime({ offset: true }),
  "state_changed_at": z.string().datetime({ offset: true }).nullable()
}).strict();

export const edgeGroupSchema = z.object({
  "id": z.string().uuid(),
  "name": z.string().min(1).max(100),
  "agent_origin": z.string().max(300),
  "revision": z.number().int().min(0),
  "authority_revision": z.number().int().min(0),
  "created_at": z.string().datetime({ offset: true }),
  "release": z.unknown().refine((value) => [z.object({
    "version": z.string().min(1).max(100),
    "sequence": z.number().int().min(1),
    "sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "image_id": z.string().regex(new RegExp("^[0-9a-f]{64}$"))
  }).strict(), z.null()].filter((variant) => variant.safeParse(value).success).length === 1, "Expected exactly one supported variant").pipe(z.union([z.object({
    "version": z.string().min(1).max(100),
    "sequence": z.number().int().min(1),
    "sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "image_id": z.string().regex(new RegExp("^[0-9a-f]{64}$"))
  }).strict(), z.null()])),
  "configuration": z.object({
    "capabilities": z.array(z.object({
      "capability": z.enum(["agent_apis", "agent_outbound", "private_applications", "private_servers"]),
      "options": z.array(z.string().min(1).max(64)).max(4),
      "paused": z.boolean().optional(),
      "min_serving": z.number().int().min(0).max(1024),
      "ssh_authority": z.object({
        "fingerprint": z.string().regex(new RegExp("^SHA256:[A-Za-z0-9+/]{43}$")),
        "custody": z.enum(["hardware", "kms", "software"])
      }).strict().optional()
    }).strict()).max(4),
    "resources": z.array(z.object({
      "id": z.string().uuid(),
      "capability": z.enum(["agent_apis", "agent_outbound", "private_applications", "private_servers"]),
      "revision": z.number().int().min(1),
      "policy_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
      "target_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$"))
    }).strict()).max(5000)
  }).strict(),
  "coverage": z.array(z.object({
    "capability": z.enum(["agent_apis", "agent_outbound", "private_applications", "private_servers"]),
    "min_serving": z.number().int().min(0),
    "serving": z.number().int().min(0),
    "edges": z.number().int().min(0),
    "redundancy": z.enum(["redundant", "none", "below_minimum"])
  }).strict()).max(4),
  "retiring": z.array(z.object({
    "capability": z.enum(["agent_apis", "agent_outbound", "private_applications", "private_servers"]),
    "retiring_at": z.string().datetime({ offset: true })
  }).strict()).max(4),
  "edges": z.array(z.object({
    "id": z.string().uuid(),
    "name": z.string().min(1).max(100),
    "failure_domain": z.string().min(1).max(100),
    "destination": z.string().min(1).max(253),
    "state": z.enum(["serving", "unreachable", "admitted", "draining", "removed", "withdrawn"]),
    "admitted_at": z.string().datetime({ offset: true }),
    "draining_since": z.string().datetime({ offset: true }).nullable(),
    "drain_deadline": z.string().datetime({ offset: true }).nullable(),
    "removed_at": z.string().datetime({ offset: true }).nullable(),
    "removed_reason": z.enum(["removed", "withdrawn"]).nullable(),
    "running_release": z.unknown().refine((value) => [z.object({
      "sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
      "version": z.string().max(100),
      "reported_at": z.string().datetime({ offset: true })
    }).strict(), z.null()].filter((variant) => variant.safeParse(value).success).length === 1, "Expected exactly one supported variant").pipe(z.union([z.object({
      "sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
      "version": z.string().max(100),
      "reported_at": z.string().datetime({ offset: true })
    }).strict(), z.null()])),
    "last_seen_at": z.string().datetime({ offset: true }).nullable(),
    "clock_skew_ms": z.number().int().nullable(),
    "ssh_authority": z.string().regex(new RegExp("^(none|SHA256:[A-Za-z0-9+/]{43})$")).nullable(),
    "open_sessions": z.number().int().min(0),
    "certificate_not_after": z.string().datetime({ offset: true }).nullable(),
    "workers": z.array(z.object({
      "worker_id": z.string().uuid(),
      "identity": z.string().regex(new RegExp("^w-[0-9a-f-]{36}$")),
      "capability": z.enum(["agent_apis", "agent_outbound", "private_applications", "private_servers"]),
      "role": z.enum(["broker", "egress", "web", "privileged"]),
      "state": z.enum(["serving", "awaiting_certificate", "draining", "retired", "revoked"])
    }).strict()).max(4)
  }).strict()).max(1024),
  "draft": z.unknown().refine((value) => [z.object({
    "revision": z.number().int().min(1),
    "base_revision": z.number().int().min(0),
    "authority_revision": z.number().int().min(0),
    "request_id": z.string().uuid(),
    "updated_at": z.string().datetime({ offset: true }),
    "capabilities": z.array(z.object({
      "capability": z.enum(["agent_apis", "agent_outbound", "private_applications", "private_servers"]),
      "enabled": z.boolean(),
      "options": z.array(z.string().min(1).max(64)).max(4),
      "paused": z.boolean().optional(),
      "min_serving": z.number().int().min(0).max(1024),
      "ssh_authority": z.object({
        "fingerprint": z.string().regex(new RegExp("^SHA256:[A-Za-z0-9+/]{43}$")),
        "custody": z.enum(["hardware", "kms", "software"])
      }).strict().nullable().optional(),
      "resources": z.array(z.string().uuid()).max(5000)
    }).strict()).max(4)
  }).strict(), z.null()].filter((variant) => variant.safeParse(value).success).length === 1, "Expected exactly one supported variant").pipe(z.union([z.object({
    "revision": z.number().int().min(1),
    "base_revision": z.number().int().min(0),
    "authority_revision": z.number().int().min(0),
    "request_id": z.string().uuid(),
    "updated_at": z.string().datetime({ offset: true }),
    "capabilities": z.array(z.object({
      "capability": z.enum(["agent_apis", "agent_outbound", "private_applications", "private_servers"]),
      "enabled": z.boolean(),
      "options": z.array(z.string().min(1).max(64)).max(4),
      "paused": z.boolean().optional(),
      "min_serving": z.number().int().min(0).max(1024),
      "ssh_authority": z.object({
        "fingerprint": z.string().regex(new RegExp("^SHA256:[A-Za-z0-9+/]{43}$")),
        "custody": z.enum(["hardware", "kms", "software"])
      }).strict().nullable().optional(),
      "resources": z.array(z.string().uuid()).max(5000)
    }).strict()).max(4)
  }).strict(), z.null()])),
  "pending_change": z.unknown().refine((value) => [edgeGroupChangeSchema, z.null()].filter((variant) => variant.safeParse(value).success).length === 1, "Expected exactly one supported variant").pipe(z.union([edgeGroupChangeSchema, z.null()])),
  "pending_admissions": z.array(edgeGroupAdmissionSchema).max(64),
  "permissions": z.object({
    "prepare": z.boolean(),
    "approve": z.boolean(),
    "manage": z.boolean()
  }).strict(),
  "second_approver": z.boolean(),
  "second_approver_updates": z.boolean(),
  "previous_release": z.unknown().refine((value) => [z.object({
    "version": z.string().min(1).max(100),
    "sequence": z.number().int().min(1),
    "sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "image_id": z.string().regex(new RegExp("^[0-9a-f]{64}$"))
  }).strict(), z.null()].filter((variant) => variant.safeParse(value).success).length === 1, "Expected exactly one supported variant").pipe(z.union([z.object({
    "version": z.string().min(1).max(100),
    "sequence": z.number().int().min(1),
    "sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "image_id": z.string().regex(new RegExp("^[0-9a-f]{64}$"))
  }).strict(), z.null()])),
  "rollout": z.unknown().refine((value) => [edgeGroupRolloutSchema, z.null()].filter((variant) => variant.safeParse(value).success).length === 1, "Expected exactly one supported variant").pipe(z.union([edgeGroupRolloutSchema, z.null()])),
  "decommission_requested_at": z.string().datetime({ offset: true }).nullable(),
  "update_estimate": z.object({
    "edges": z.number().int().min(0),
    "per_edge_seconds": z.number().int().min(1),
    "measured_updates": z.number().int().min(0),
    "halt_after_seconds": z.number().int().min(1)
  }).strict(),
  "names": z.unknown().refine((value) => [z.object({
    "zone": z.string(),
    "name": z.string(),
    "forwarder": z.object({
      "zone": z.string(),
      "servers": z.array(z.string()).max(1024),
      "resolver": z.array(z.string()).max(8),
      "verify": z.array(z.string()).max(8)
    }).strict(),
    "records": z.array(z.object({
      "name": z.string(),
      "type": z.enum(["A", "AAAA"]),
      "value": z.string(),
      "ttl": z.number().int().min(1)
    }).strict()).max(64),
    "addresses_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "static_records": z.unknown().refine((value) => [z.object({
      "addresses": z.array(z.string()).max(64),
      "issued_by": z.string().uuid(),
      "issued_at": z.string().datetime({ offset: true }),
      "stale_since": z.string().datetime({ offset: true }).nullable()
    }).strict(), z.null()].filter((variant) => variant.safeParse(value).success).length === 1, "Expected exactly one supported variant").pipe(z.union([z.object({
      "addresses": z.array(z.string()).max(64),
      "issued_by": z.string().uuid(),
      "issued_at": z.string().datetime({ offset: true }),
      "stale_since": z.string().datetime({ offset: true }).nullable()
    }).strict(), z.null()]))
  }).strict(), z.null()].filter((variant) => variant.safeParse(value).success).length === 1, "Expected exactly one supported variant").pipe(z.union([z.object({
    "zone": z.string(),
    "name": z.string(),
    "forwarder": z.object({
      "zone": z.string(),
      "servers": z.array(z.string()).max(1024),
      "resolver": z.array(z.string()).max(8),
      "verify": z.array(z.string()).max(8)
    }).strict(),
    "records": z.array(z.object({
      "name": z.string(),
      "type": z.enum(["A", "AAAA"]),
      "value": z.string(),
      "ttl": z.number().int().min(1)
    }).strict()).max(64),
    "addresses_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "static_records": z.unknown().refine((value) => [z.object({
      "addresses": z.array(z.string()).max(64),
      "issued_by": z.string().uuid(),
      "issued_at": z.string().datetime({ offset: true }),
      "stale_since": z.string().datetime({ offset: true }).nullable()
    }).strict(), z.null()].filter((variant) => variant.safeParse(value).success).length === 1, "Expected exactly one supported variant").pipe(z.union([z.object({
      "addresses": z.array(z.string()).max(64),
      "issued_by": z.string().uuid(),
      "issued_at": z.string().datetime({ offset: true }),
      "stale_since": z.string().datetime({ offset: true }).nullable()
    }).strict(), z.null()]))
  }).strict(), z.null()])),
  "health": z.enum(["serving", "degraded", "down", "unknown"])
}).strict();

export const edgeGroupsSchema = z.object({
  "groups": z.array(edgeGroupSchema).max(64)
}).strict();

export const edgeGroupPendingSchema = z.object({
  "pending": z.number().int().min(0)
}).strict();

export const edgeGroupDraftRequestSchema = z.object({
  "request_id": z.string().uuid(),
  "expected_revision": z.number().int().min(0),
  "capabilities": z.array(z.object({
    "capability": z.enum(["agent_apis", "agent_outbound", "private_applications", "private_servers"]),
    "enabled": z.boolean(),
    "options": z.array(z.string().min(1).max(64)).max(4),
    "paused": z.boolean().optional(),
    "min_serving": z.number().int().min(0).max(1024),
    "ssh_authority": z.object({
      "fingerprint": z.string().regex(new RegExp("^SHA256:[A-Za-z0-9+/]{43}$")),
      "custody": z.enum(["hardware", "kms", "software"])
    }).strict().nullable().optional(),
    "resources": z.array(z.string().uuid()).max(5000)
  }).strict()).min(4).max(4)
}).strict();

export const edgeGroupChangeRequestSchema = z.object({
  "request_id": z.string().uuid(),
  "expected_draft_revision": z.number().int().min(1),
  "release_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
  "drain_seconds": z.number().int().min(0).max(3600).optional(),
  "ticket_reference": z.string().max(128).optional()
}).strict();

export const edgeGroupUpdateRequestSchema = z.object({
  "request_id": z.string().uuid(),
  "release_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")).optional(),
  "rollback": z.boolean().optional(),
  "window_start": z.string().datetime({ offset: true }).optional(),
  "window_end": z.string().datetime({ offset: true }).optional(),
  "ticket_reference": z.string().max(128).optional()
}).strict();

export const edgeGroupChangesSchema = z.object({
  "changes": z.array(z.object({
    "id": z.string().uuid(),
    "kind": z.enum(["configuration", "update", "rollback"]),
    "ticket_reference": z.string().nullable(),
    "prepared_by": z.string().uuid(),
    "prepared_at": z.string().datetime({ offset: true }),
    "phase": z.enum(["pending", "approved", "cancelled", "expired"]),
    "decided_at": z.string().datetime({ offset: true }).nullable(),
    "from_release": z.string().nullable(),
    "to_release": z.string(),
    "rollout_state": z.enum(["running", "paused", "halted", "completed", "cancelled", "superseded"]).nullable()
  }).strict()).max(50)
}).strict();

export const edgeGroupNamesRequestSchema = z.object({
  "mode": z.enum(["forwarder", "static"]),
  "addresses_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")).optional()
}).strict();

export const edgeGroupChangeEvidenceSchema = z.object({
  "format": z.enum(["pureid-edge-group-change-evidence-v1"]),
  "generated_at": z.string().datetime({ offset: true }),
  "tenant_id": z.string().uuid(),
  "group_id": z.string().uuid(),
  "group_name": z.string(),
  "summary": z.object({
    "id": z.string().uuid(),
    "kind": z.enum(["configuration", "update", "rollback"]),
    "ticket_reference": z.string().nullable(),
    "prepared_by": z.string().uuid(),
    "prepared_at": z.string().datetime({ offset: true }),
    "phase": z.enum(["pending", "approved", "cancelled", "expired"]),
    "decided_at": z.string().datetime({ offset: true }).nullable(),
    "from_release": z.string().nullable(),
    "to_release": z.string(),
    "rollout_state": z.enum(["running", "paused", "halted", "completed", "cancelled", "superseded"]).nullable()
  }).strict(),
  "change_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
  "change": z.string(),
  "prepared_by": z.object({
    "id": z.string().uuid(),
    "name": z.string(),
    "email": z.string()
  }).strict(),
  "decided_by": z.string().uuid().nullable(),
  "approvals": z.array(z.object({
    "approval_id": z.string().uuid(),
    "approver": z.object({
      "id": z.string().uuid(),
      "name": z.string(),
      "email": z.string()
    }).strict(),
    "scope": z.enum(["tenant_admin", "platform_admin"]),
    "tenant_grant_id": z.string().uuid().nullable(),
    "self_approved": z.boolean(),
    "subject": z.string(),
    "subject_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "challenge": z.string().regex(new RegExp("^[A-Za-z0-9+/]*={0,2}$")),
    "rp_id": z.string(),
    "origin": z.string(),
    "credential_id": z.string().regex(new RegExp("^[A-Za-z0-9+/]*={0,2}$")),
    "credential_public_key": z.string().regex(new RegExp("^[A-Za-z0-9+/]*={0,2}$")),
    "assertion": z.string(),
    "assertion_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "verified_at": z.string().datetime({ offset: true })
  }).strict()).max(16),
  "rollout": z.unknown().refine((value) => [z.object({
    "state": z.enum(["running", "paused", "halted", "completed", "cancelled", "superseded"]),
    "started_at": z.string().datetime({ offset: true }),
    "state_changed_at": z.string().datetime({ offset: true }).nullable(),
    "steps": z.array(z.object({
      "edge_id": z.string().uuid(),
      "edge_name": z.string(),
      "started_at": z.string().datetime({ offset: true }),
      "finished_at": z.string().datetime({ offset: true }).nullable(),
      "outcome": z.enum(["updated", "halted", "paused", "cancelled", "superseded", "removed"]).nullable()
    }).strict()).max(4096)
  }).strict(), z.null()].filter((variant) => variant.safeParse(value).success).length === 1, "Expected exactly one supported variant").pipe(z.union([z.object({
    "state": z.enum(["running", "paused", "halted", "completed", "cancelled", "superseded"]),
    "started_at": z.string().datetime({ offset: true }),
    "state_changed_at": z.string().datetime({ offset: true }).nullable(),
    "steps": z.array(z.object({
      "edge_id": z.string().uuid(),
      "edge_name": z.string(),
      "started_at": z.string().datetime({ offset: true }),
      "finished_at": z.string().datetime({ offset: true }).nullable(),
      "outcome": z.enum(["updated", "halted", "paused", "cancelled", "superseded", "removed"]).nullable()
    }).strict()).max(4096)
  }).strict(), z.null()]))
}).strict();

export const edgeGroupDecommissionedSchema = z.object({
  "id": z.string().uuid(),
  "requested_at": z.string().datetime({ offset: true }),
  "draining": z.number().int().min(0),
  "retired_at": z.string().datetime({ offset: true }).nullable()
}).strict();

export const edgeGroupReleasesSchema = z.object({
  "releases": z.array(z.object({
    "version": z.string().min(1).max(100),
    "sequence": z.number().int().min(1),
    "sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "published_at": z.string().datetime({ offset: true }),
    "current": z.boolean()
  }).strict()).max(20)
}).strict();

export const edgeGroupJoinTokenSchema = z.object({
  "id": z.string().uuid(),
  "group_id": z.string().uuid(),
  "issued_by": z.string().uuid(),
  "issued_at": z.string().datetime({ offset: true }),
  "expires_at": z.string().datetime({ offset: true }),
  "max_admissions": z.number().int().min(1).max(64),
  "used_admissions": z.number().int().min(0).max(64),
  "revoked_at": z.string().datetime({ offset: true }).nullable(),
  "last_used_at": z.string().datetime({ offset: true }).nullable(),
  "last_used_from": z.string().max(64).nullable(),
  "remaining_uses": z.number().int().min(0).max(64),
  "usable": z.boolean()
}).strict();

export const edgeGroupJoinTokensSchema = z.object({
  "tokens": z.array(edgeGroupJoinTokenSchema).max(50)
}).strict();

export const edgeGroupJoinTokenIssuedSchema = z.object({
  "token": z.string().regex(new RegExp("^pgj_[A-Za-z0-9_-]{43}$")),
  "install": z.unknown().refine((value) => [z.object({
    "issuer": z.string().url().max(300),
    "release": z.object({
      "version": z.string().min(1).max(100),
      "sequence": z.number().int().min(1),
      "sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
      "image_id": z.string().regex(new RegExp("^[0-9a-f]{64}$"))
    }).strict(),
    "binary_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "binary_url": z.string().url().max(600)
  }).strict(), z.null()].filter((variant) => variant.safeParse(value).success).length === 1, "Expected exactly one supported variant").pipe(z.union([z.object({
    "issuer": z.string().url().max(300),
    "release": z.object({
      "version": z.string().min(1).max(100),
      "sequence": z.number().int().min(1),
      "sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
      "image_id": z.string().regex(new RegExp("^[0-9a-f]{64}$"))
    }).strict(),
    "binary_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "binary_url": z.string().url().max(600)
  }).strict(), z.null()])),
  "command": z.string().max(2048).nullable(),
  "id": z.string().uuid(),
  "group_id": z.string().uuid(),
  "issued_by": z.string().uuid(),
  "issued_at": z.string().datetime({ offset: true }),
  "expires_at": z.string().datetime({ offset: true }),
  "max_admissions": z.number().int().min(1).max(64),
  "used_admissions": z.number().int().min(0).max(64),
  "revoked_at": z.string().datetime({ offset: true }).nullable(),
  "last_used_at": z.string().datetime({ offset: true }).nullable(),
  "last_used_from": z.string().max(64).nullable(),
  "remaining_uses": z.number().int().min(0).max(64),
  "usable": z.boolean()
}).strict();

export const edgeGroupJoinTokenRequestSchema = z.object({
  "edges": z.number().int().min(1).max(64),
  "lifetime_seconds": z.number().int().min(60).max(86400).optional()
}).strict();

export const edgeGroupApprovalBeginRequestSchema = z.object({
  "change_id": z.string().uuid().nullable().optional(),
  "admissions": z.array(z.string().uuid()).max(64).optional()
}).strict();

export const edgeGroupApprovalBeginResponseSchema = z.object({
  "approval_id": z.string().uuid(),
  "options": edgeAssertionOptionsSchema
}).strict();

export const edgeGroupApprovalFinishRequestSchema = z.object({
  "assertion": z.string().regex(new RegExp("^[A-Za-z0-9+/]*={0,2}$")).max(87400)
}).strict();

export const edgeGroupApprovalResultSchema = z.object({
  "approval_id": z.string().uuid(),
  "change_id": z.string().uuid().nullable(),
  "admissions": z.array(z.string().uuid()).max(64),
  "revision": z.number().int().min(0),
  "self_approved": z.boolean()
}).strict();

export const edgeGroupRetirementReceiptSchema = z.object({
  "signature": z.string().regex(new RegExp("^[A-Za-z0-9+/]+={0,2}$")),
  "retirement": z.object({
    "format": z.enum(["pureid.edge-retirement.v1"]),
    "tenant_id": z.string().uuid(),
    "group_id": z.string().uuid(),
    "edge_id": z.string().uuid(),
    "tenant_retired": z.boolean().optional(),
    "workers": z.array(z.string().uuid()).max(4096),
    "retired_at": z.string().datetime({ offset: true }),
    "issued_at": z.string().datetime({ offset: true })
  }).strict()
}).strict();

export const edgeGroupRemovalRequestSchema = z.object({
  "drain_seconds": z.number().int().min(0).max(3600),
  "reason": z.string().min(1).max(500),
  "connections": z.number().int().min(0).nullable().optional()
}).strict();

export const edgeGroupRemovalResponseSchema = z.object({
  "group": edgeGroupSchema,
  "removal_id": z.string().uuid()
}).strict();

export const edgeGroupWithdrawalRequestSchema = z.object({
  "edge_id": z.string().uuid().nullable().optional(),
  "worker_id": z.string().uuid().nullable().optional(),
  "reason": z.string().min(1).max(500)
}).strict();

export const edgeGroupWithdrawalResponseSchema = z.object({
  "group": edgeGroupSchema,
  "revoked": z.array(z.string().regex(new RegExp("^w-[0-9a-f-]{36}$"))).max(1024)
}).strict();

export const edgeGroupDoorAuthoritySchema = z.object({
  "root_pem": z.string().max(16384)
}).strict();

export const edgeGroupApprovalPolicySchema = z.object({
  "second_approver": z.boolean(),
  "include_updates": z.boolean(),
  "changed_by": z.string().uuid().nullable(),
  "changed_at": z.string().datetime({ offset: true }).nullable()
}).strict();

export const relayAdmissionPolicySchema = z.object({
  "mode": z.enum(["portal_launched", "declared_egress", "any_source"]),
  "declared_egress_ranges": z.array(z.string()),
  "updated_at": z.string().datetime({ offset: true }).optional()
}).strict();

export const servingCertificateRevocationSchema = z.object({
  "reason": z.enum(["key_compromise", "superseded", "cessation_of_operation"]),
  "requested_at": z.string().datetime({ offset: true }),
  "revoked_at": z.string().datetime({ offset: true }).optional(),
  "attempts": z.number().int(),
  "last_error": z.string().optional()
});

export const servingCertificateSchema = z.object({
  "order_id": z.string().uuid(),
  "names": z.array(z.string()),
  "serial": z.string(),
  "not_after": z.string().datetime({ offset: true }),
  "renew_after": z.string().datetime({ offset: true }),
  "revocation": servingCertificateRevocationSchema.optional()
});

export const outsideCertificateSchema = z.object({
  "serial": z.string(),
  "issuer": z.string(),
  "names": z.array(z.string()),
  "not_before": z.string().datetime({ offset: true }),
  "not_after": z.string().datetime({ offset: true }),
  "uncollected": z.boolean()
});

export const issuanceObservationSchema = z.object({
  "checked_at": z.string().datetime({ offset: true }).optional(),
  "outside": z.array(outsideCertificateSchema)
});

export const servingCertificateListSchema = z.object({
  "items": z.array(servingCertificateSchema),
  "observation": issuanceObservationSchema.optional()
});
